var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"modal-container"}},[_c('div',{staticClass:"fixed z-1022 bg-white rounded shadow-sm",attrs:{"id":"modal-content"}},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"fixed w-full h-full opacity-50 bg-black inset-0 z-1021",attrs:{"id":"modal-bg"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }